import md5 from 'md5';

export const generateMd5 = (mobileNumber: string) => {
   const randomString =
      Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

   return `${md5(mobileNumber + randomString)}|${randomString}`;
};
